import {ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {NavService} from '@core/nav.service';

/*import { MatCarousel, MatCarouselComponent } from 'ng-mat-carousel';*/
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  pcUrl = '';
  constructor(public nav: NavService, private cdr: ChangeDetectorRef) {
    this.pcUrl = this.nav.env.pcUrl;

  }


}
